import { render } from "./ChatInbox.vue?vue&type=template&id=c072a95e"
import script from "./ChatInbox.vue?vue&type=script&lang=js"
export * from "./ChatInbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__